// extracted by mini-css-extract-plugin
module.exports = {"btnGreen":"styles_btnGreen__39JqY","btnRed":"styles_btnRed__1jYDE","title":"styles_title__1FyhM","table":"styles_table__ls0GE","pagination":"styles_pagination__3RKG6"};